import styled from '@emotion/styled';
import { Spacings, Fonts } from '@styles/index';
import useMaxAttemptQuestions from '@cont/Quiz/Taking/Common/useMaxAttemptQuestions';
import H6 from '@base/H6/H6';

const SectionInfoLeft = styled.div`
  padding: 0 ${Spacings.SPACING_6B};
`;

const SectionMaxAttemptInfo = styled.div`
  font-size: ${Fonts.ULTRA_SMALL};
  margin-top: ${Spacings.SPACING_2};
  color: var(--color-text-secondary);
`;

const StyledH6 = styled(H6)`
  line-height: 18px;
`;

const QuestionsInfo = ({ title, sectionUID }) => {
  const { isMaxQuestionAttemptEnabled, maxAnswerableQuestion } =
    useMaxAttemptQuestions(sectionUID);

  const getAttemptInfo = () => {
    if (isMaxQuestionAttemptEnabled) {
      return `Attempt ${maxAnswerableQuestion}`;
    }

    return 'Attempt all';
  };

  return (
    <div>
      <SectionInfoLeft>
        <StyledH6 lineClamp={2}>{title}</StyledH6>
        <SectionMaxAttemptInfo>{getAttemptInfo()}</SectionMaxAttemptInfo>
      </SectionInfoLeft>
    </div>
  );
};

export default QuestionsInfo;
